import React, { useEffect, useState } from 'react';
import { CandlestickTileChart } from 'widgets/candlestickTile/components/chart/CandlestickTileChart';
import { CandlestickTileData } from 'widgets/candlestickTile/candlestickTileData';
import ReactCardFlip from 'react-card-flip';
import { CandlestickTileValues } from 'widgets/candlestickTile/components/values/CandlestickTileValues';

import { CandlestickTileConfigState } from 'widgets/candlestickTile/store/config/CandlestickTileConfigState';

interface CandlestickTileContentProps {
    symbol?: string;
    capsuleKey: string;
    data?: CandlestickTileData;
    config: CandlestickTileConfigState;
    dispatchConfigChanged: (
        configDelta: Partial<CandlestickTileConfigState>
    ) => void;
}
export function CandlestickTileContent(props: CandlestickTileContentProps) {
    const { data, config, dispatchConfigChanged, symbol, capsuleKey } = props;
    const { view } = config;

    const [time, setTime] = useState<number | undefined>();

    useEffect(() => {
        setTime(undefined);
    }, [symbol]);

    const isFlipped = view === 'values';

    if (!data) {
        return <div className="CandlestickTileContent">No data</div>;
    }

    const onChartClick = (nextTime?: number) => {
        setTime(nextTime);
        if (nextTime !== undefined) {
            dispatchConfigChanged({ view: 'values' });
        }
    };

    return (
        <div className="CandlestickTileContent">
            <ReactCardFlip isFlipped={isFlipped} flipDirection={'vertical'}>
                <CandlestickTileChart
                    key="front"
                    data={data}
                    onClick={onChartClick}
                    chartKey={capsuleKey}
                />
                <CandlestickTileValues
                    key="back"
                    data={data}
                    time={time}
                    onClick={() => dispatchConfigChanged({ view: 'chart' })}
                />
            </ReactCardFlip>
        </div>
    );
}
